import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAddressViaZipCodeUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetAddressViaZipCode
  implements GetAddressViaZipCodeUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAddressViaZipCodeUseCaseInterface.Params,
  ): Promise<GetAddressViaZipCodeUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.zipCode}/json`,
      method: 'get',
      headers: {
        withCredentials: false,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
